var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    className: "add",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.add .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CDD0D4;}\n\t.add .st1{fill:#74797D;}\n\t.add .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#74797D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,3.5h7c2.8,0,5,2.2,5,5v7c0,2.8-2.2,5-5,5h-7c-2.8,0-5-2.2-5-5v-7C3.5,5.7,5.7,3.5,8.5,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,21h-7c-3,0-5.5-2.5-5.5-5.5v-7C3,5.5,5.5,3,8.5,3h7c3,0,5.5,2.5,5.5,5.5v7C21,18.5,18.5,21,15.5,21z  M8.5,4C6,4,4,6,4,8.5v7C4,18,6,20,8.5,20h7c2.5,0,4.5-2,4.5-4.5v-7C20,6,18,4,15.5,4H8.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,11h4v2h-4v4h-2v-4H7v-2h4V7h2V11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.b155bf2c352807d3c15e1f54f7871354.svg";
export { ForwardRef as ReactComponent };